import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventAction, GaTrackingEventName, GATrackingEventType} from '../../constants';

export class GaTrackingCheckoutFunnelEventModel implements GATrackingEvent {

  constructor(private label: string) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.CheckoutStepper;
  }

  getPayload(): GATrackingEventPayload {
    return {
      label: this.label,
      event: GaTrackingEventName.CheckoutStepper,
      gtmCustom: {
        action: GaTrackingEventAction.ExtendedCheckout
      }
    };
  }
}
